/**
 * Google Consent Mode v2 defaults and updates for gtag.
 */

import {
  CONSENT_ACCEPTED,
  CONSENT_REJECTED,
  hasAnalyticsConsent,
} from './cookieConsent';

const GA_ID = (process.env.REACT_APP_GA_MEASUREMENT_ID || '').trim();

let shellReady = false;

const consentDenied = {
  ad_storage: 'denied',
  ad_user_data: 'denied',
  ad_personalization: 'denied',
  analytics_storage: 'denied',
  functionality_storage: 'denied',
  personalization_storage: 'denied',
  security_storage: 'granted',
};

const consentGranted = {
  ad_storage: 'granted',
  ad_user_data: 'granted',
  ad_personalization: 'granted',
  analytics_storage: 'granted',
  functionality_storage: 'granted',
  personalization_storage: 'granted',
  security_storage: 'granted',
};

/**
 * Bootstrap gtag with Consent Mode default denied (cookieless pings allowed).
 *
 * @returns {boolean} True when the GA shell is ready.
 */
export const ensureGaConsentShell = () => {
  if (!GA_ID || shellReady || typeof window === 'undefined') {
    return shellReady;
  }
  shellReady = true;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  };

  window.gtag('consent', 'default', {
    ...consentDenied,
    wait_for_update: 500,
  });
  window.gtag('js', new Date());
  window.gtag('config', GA_ID, { send_page_view: false });

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(GA_ID)}`;
  document.head.appendChild(script);

  applyStoredConsentUpdate();
  return true;
};

/**
 * Sync gtag consent flags with the stored banner choice.
 */
export const applyStoredConsentUpdate = () => {
  if (typeof window.gtag !== 'function') return;
  if (hasAnalyticsConsent()) {
    window.gtag('consent', 'update', consentGranted);
  } else {
    // Denied until Accept (and after Reject). Unchosen users stay on default denied.
    window.gtag('consent', 'update', consentDenied);
  }
};

/**
 * Update consent after Accept / Reject in the banner.
 *
 * @param {'accepted'|'rejected'} value
 */
export const updateGaConsent = (value) => {
  if (typeof window.gtag !== 'function') return;
  if (value === CONSENT_ACCEPTED) {
    window.gtag('consent', 'update', consentGranted);
  } else if (value === CONSENT_REJECTED) {
    window.gtag('consent', 'update', consentDenied);
  }
};

export const isGaShellReady = () => shellReady;

export { GA_ID };
